module.exports = __webpack_public_path__ + "img/candidate_current_placeholder_transparent.09e07826.png";